export const FIREBASE_CONFIG = {
	apiKey: 'AIzaSyAa6A82tLhdyeG2hjUM_LeIphCT1-vmiPM',
	authDomain: 'my-rasoi.firebaseapp.com',
	databaseURL: 'https://my-rasoi-default-rtdb.firebaseio.com',
	projectId: 'my-rasoi',
	storageBucket: 'my-rasoi.appspot.com',
	messagingSenderId: '872658465108',
	appId: '1:872658465108:web:6fa316525d5a6aa93218c1',
	measurementId: 'G-KL0YK7PB1X',
};

export const FIREBASE_PUBLIC_VAPID =
	'BHqVcZK2AxSsYM7a7nhftPx6S4pb6A0HQWx7rubKNap23FSNOPDshdoMK3G4AAvlvumIzOFg5sZN0HnzZHXqhxM';

export const NOTIFICATION_PERMISSION = {
	GRANTED: 'granted',
	DENIED: 'denied',
};
